<template>
  <a-layout-sider
    :style="{ minHeight: '100vh' }"
    breakpoint="sm"
    collapsedWidth="0"
    v-model="collapsed"
  >
    <div class="logo"></div>
    <a-menu
      theme="dark"
      mode="inline"
      :defaultSelectedKeys="['home']"
      :defaultOpenKeys="['covid', 'latimes', 'nytimes']"
      >
      <a-menu-item key="home">
        <router-link to="/">Home</router-link>
      </a-menu-item>

      <!-- <a-menu-item key="about">
        <router-link to="/about">About</router-link>
      </a-menu-item> -->

      <a-sub-menu key="covid">
        <span slot="title"><span>COVID-19</span></span>
        <!-- <a-icon type="appstore" /> -->
        <a-sub-menu key="latimes">
          <span slot="title"><span>LA Times</span></span>
          <a-menu-item key="la-agency-totals">
            <router-link :to="{ name: 'la-agency-totals' }">Agency Totals</router-link>
          </a-menu-item>
          <a-menu-item key="la-place-totals">
            <router-link :to="{ name: 'la-place-totals' }">Place Totals</router-link>
          </a-menu-item>
        </a-sub-menu>

        <a-sub-menu key="nytimes">
          <span slot="title"><span>NY Times</span></span>
          <a-menu-item key="ny-national">
            <router-link :to="{ name: 'ny-national' }">National</router-link>
          </a-menu-item>
          <a-menu-item key="ny-state">
            <router-link :to="{ name: 'ny-state' }">State</router-link>
          </a-menu-item>
          <a-menu-item key="ny-county">
            <router-link :to="{ name: 'ny-county' }">County</router-link>
          </a-menu-item>
        </a-sub-menu>

        <!-- <a-sub-menu key="nytimes">
          <span slot="title"><span>NY Times</span></span>
          <a-menu-item key="ny">Agency Totals</a-menu-item>
        </a-sub-menu> -->
      </a-sub-menu>

      <a-menu-item key="usage"><router-link :to="{ name: 'usage' }">Usage</router-link></a-menu-item>

    </a-menu>
  </a-layout-sider>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
  },
  data() {
    return {
      collapsed: false,
      current: ['home'],
    };
  },
  computed: {
    // currentPage() {
    //   if (this.$route.name !== null) {
    //     // this.current = [this.$route.name];
    //     return [this.$route.name];
    //   }
    //
    //   return ['home'];
    // },
  },
  methods: {

  },
  mounted() {
    // console.log(this.$route.name);
    // this.current = [this.$route.name];
  },
};
</script>
<style>
.ant-layout-sider-zero-width-trigger {
  top: 4px;
}
#components-layout-demo-side .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}
</style>
